<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        deviceType: null,
      }
    },
    mounted () {},
    methods: {},
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue